import Vue from 'vue';
import Router from 'vue-router';
import ApplicationLayout from '@/components/layouts/application';
import PageNotFound from '@/components/page-not-found';
import { authenticateRequest, AUTH_ROUTES } from './auth';
import ADMIN_ROUTES from './admin';
import AGENT_ROUTES from './agents';
import DEVICES_ROUTES from './devices';
import EVENTS_ROUTES from './events';
import PROJECTS_ROUTES from './projects';
import SUBSTATIONS_ROUTES from './substations';
import VISNET_HUBS_ROUTES from './visnet-hub';
import GUARDS_1000_ROUTES from './guards-1000';

Vue.use(Router);

const router = new Router({
  routes: [
    ...AUTH_ROUTES,
    {
      path: '/',
      component: ApplicationLayout,
      children: [
        ...AGENT_ROUTES,
        ...DEVICES_ROUTES,
        ...EVENTS_ROUTES,
        ...PROJECTS_ROUTES,
        ...SUBSTATIONS_ROUTES,
        ...ADMIN_ROUTES,
        ...VISNET_HUBS_ROUTES,
        ...GUARDS_1000_ROUTES
      ]
    },
    {
      path: '/not-found',
      name: 'notFound',
      component: PageNotFound
    },
    {
      path: '*',
      redirect: '/not-found'
    }
  ]
});

router.beforeEach(authenticateRequest);

export default router;
